const Layout1 = ({ applicant }) => {
    return (
        <>
            <div className='RegisteredApplicant__Info'>
                <p className='RegisteredApplicant__Info__Text--Highlight'>PROCESO PARA EL ACCESO AL EXAMEN DE ADMISIÓN:</p>
                <ol className='RegisteredApplicant__Info__OrderedList'>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Asiste al plantel el día <span className='RegisteredApplicant__Info__Text--Highlight'>4 de julio de 2026</span>, presentando tu ficha de acceso al examen (este documento) y una identificación oficial (INE, pasaporte o credencial escolar vigente).</li>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>El horario de aplicación del examen se te asignará y notificará los días <span className='RegisteredApplicant__Info__Text--Highlight'>25 y 26 de junio de 2026</span>.</li>
                </ol>
            </div>
        </>
    )
}

export { Layout1 };